import axios from "axios"
import { getUrlParam } from "helper"
import ActionTypes from 'redux/ActionTypes'
import { setMsg, showCloseIcon, toggleError, toggleModal } from "./modal"
// import { set_hash } from './auth';
// import { put_hash } from './hash';

export const toggle_popup = (bool, tipe) => ({
	type: "TOGGLE_POPUP",
	bool,
	tipe,
})

export const toggle_loader = (data) => ({
	type: "TOGGLE_LOADER",
	data: data,
})

export const toggle_loader_hash = (data) => ({
	type: "TOGGLE_LOADER_HASH",
	data: data,
})

export const put_data = (key, data) => ({
	type: "PUT_DATA",
	key,
	data,
})

export const setData = (key, data) => ({
	type: ActionTypes.SET_DATA,
	payload: {
		key,
		data,
	},
});

/**
 *
 * Example of how to call API
 *
 */
export const login = () => {
	return (dispatch, getState) => {
		// UNCOMMENT & ADD DEFAULT LANG AS PARAM ex: 'EN'
		// dispatch(get_translate('EN'))
		dispatch(toggle_loader(true))

		axios
			.get(process.env.REACT_APP_API_ENDPOINT)
			.then((resp) => {
				dispatch(put_data("login", resp.data))

				/*
					If you want to set the data as HASH, 
					replace the key below with a hash key and 
					don't forget to include the state key into 
					whitelist in reducers/index.js
				*/
				// const key = 'login';
				// const { temp_hash } = getState().hash;
				// if (temp_hash[key].type === 'set_hash') {
				//   dispatch(set_hash(key));
				// } else {
				//   dispatch(put_hash(key, temp_hash[key].data));
				// }
			})
			.catch((err) => {
				// dispatch(catch_error(err_msg(err)))
			})
			.then(() => {
				dispatch(toggle_loader(false))
			})
	}
}

const isUncloseable = (msg) => {
    const listMsg = [
        'invalid_region',
        'missing_user_data',
        'error_gop',
        'missing_open_id',
        'maintenance',
        'no_token',
        'no_characters',
        'event_finished',
        'event_not_open',
        'not_logged_in',
    ];
    return listMsg.includes(msg);
};


/**
 *
 * Example of how to catch error if not logged in
 *
 */
export const catchError = ({ msg }) => {
	return (dispatch, getState) => {
		if (msg === "not_logged_in" && !(window.location.href.includes('run'))) {
			// const { auth } = getState()
			// window.location.href = `${`${process.env.REACT_APP_BASE_URL}?access_token=${auth.param.access_token}&account_id=${auth.param.account_id}&region=${auth.param.region}`}`
		} else {
			if (msg) {
                if (isUncloseable(msg)) {
                    dispatch(showCloseIcon(false));
                } else {
                    dispatch(showCloseIcon(true));
                }    
			}
            msg = dispatch(catchErrorCallback(msg));
            dispatch(setMsg(msg));
            dispatch(toggleError(true));
            dispatch(toggleModal('ModalMessage', true));
		}

		if (msg === "invalid_region") {
			localStorage.clear()
		}
	}
}

export const catchErrorCallback = (msg) => {
    return (dispatch) => {
        const errorMapper = {
            1: 'err_1',
            2: 'err_2',
            3: 'err_3',
            4: 'err_4',
            5: 'err_5',
            m: 'maintenance',
        };
        const err = getUrlParam('err');
        if (err) {
            msg = errorMapper[err] || err;
            dispatch(showCloseIcon(false));
        }
        return msg;
    };
};

